import React from "react";
import { useQuery } from "react-query";
import { _api_get_soldes } from "../api";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constants/routes";
import { useSetStep } from "../stores/useStepNumber";
import { useUserOffboarding } from "./useUserOffboarding";

const useLogicStepSolde = () => {
    // * HOOKS
    // * HOOKS
    // * HOOKS
    useSetStep(3); // on est a la 3eme étape
    const { user_offboarding } = useUserOffboarding();

    // * STATES
    // * STATES
    // * STATES
    const navigate = useNavigate();

    // * CONSTANTS
    const QUERY_KEY = "SOLDES";

    // * QUERIES & MUTATIONS
    // * QUERIES & MUTATIONS
    // * QUERIES & MUTATIONS
    const { data: soldes, isLoading } = useQuery([QUERY_KEY], () =>
        _api_get_soldes({ id_user: user_offboarding.id })
    );

    // * FUNCTIONS
    // * FUNCTIONS
    // * FUNCTIONS
    const format_data_solde = (soldes) => {
        return {
            current_balances: soldes.current_balances.map((solde) => ({
                current_value: solde.current_value,
                name: solde.name,
                balance_value_to_remove: solde.balance_value_to_remove,
                period_start_date: solde.period_start_date,
                period_end_date: solde.period_end_date,
                balance_on_end_period: solde.balance_on_end_period,
            })),
            futur_balances: soldes.futur_balances.map((solde) => ({
                current_value: solde.value,
                name: solde.leave_name,
                balance_value_to_remove: solde.pending_value,
                period_start_date: null,
                period_end_date: null,
                balance_on_end_period: null,
            })),
            leave_policy_name: soldes.leave_policy_name,
        };
    };

    return {
        query: {
            data: soldes,
            isLoading,
            formated_data: soldes ? format_data_solde(soldes) : null,
        },
        navigation: {
            buttonNextStep: () => {
                return navigate(
                    `${ROUTES.offboarding.prepare_offboarding}/equipments_access${location.search}`
                );
            },
            buttonBackStep: () => {
                return navigate(
                    `${ROUTES.offboarding.prepare_offboarding}/justification${location.search}`
                );
            },
        },
    };
};

export default useLogicStepSolde;
